import Spinner from "react-bootstrap/Spinner";

function CustomSpinner() {
  return <Spinner animation="border" role="status" size="sm" />;
}

export default CustomSpinner;
